'use client';

import { useCallback, useEffect, useState } from "react";
import { useOrg, errText } from "../internals";

export const useOrgSettings = () => {
  const { storage } = useOrg();
  const [org, setOrg] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    setError(null);
    try {
      setOrg(await storage.getOrg());
    } catch (e) {
      setError(errText(e));
    } finally {
      setLoading(false);
    }
  }, [storage]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { org, loading, error, refresh, setOrg };
};
